export const money = (cents: number): string =>
  "$" + Math.round(cents / 100).toLocaleString("en-US");

export const cpr = (cents: number | null): string =>
  cents == null ? "-" : "$" + (cents / 100).toFixed(2);

export const num = (n: number): string => n.toLocaleString("en-US");
